<template>
  <div class="relative py-16 px-8" :class="[colorClass]">
    <slot></slot>
  </div>
  <!-- Declare programatically calculated classes for tailwind to compile. -->
  <!-- <div class="bg-theme-pink"></div> -->
</template>

<script>
export default {
  name: 'SectionContainer',
  props: {
    color: String,
  },
  data() {
    return {
      colorClass: this.color ? 'bg-' + this.color : undefined,
    }
  }
}
</script>